export default __webpack_public_path__ + "static/media/scribble.6466a8c8.jpg";